module.exports = __webpack_public_path__ + "img/14.cbd22a61.png";